export enum GSMServiceKind {
  GFS = "GFS",
  HTZ = "HTZ",
  QPM = "QPM",
  RLT = "RLT",
  UNDEFINED = "UNDEFINED",
  VBS = "VBS",
}

export const ServiceKindList: GSMServiceKind[] = [
  GSMServiceKind.HTZ,
  GSMServiceKind.GFS,
  GSMServiceKind.QPM,
  GSMServiceKind.RLT,
  GSMServiceKind.VBS,
];

export function parseServiceKind(str: string): GSMServiceKind | undefined {
  switch (str.toLowerCase()) {
    case "gfs":
      return GSMServiceKind.GFS;
    case "htz":
      return GSMServiceKind.HTZ;
    case "rlt":
      return GSMServiceKind.RLT;
    case "vbs":
      return GSMServiceKind.VBS;
    case "qpm":
      return GSMServiceKind.QPM;
    default:
      return GSMServiceKind.UNDEFINED;
  }
}
